<header class="panel-header">
  <h1>Organizational Profile</h1>
  <p>Define the target entity for the exercise.</p>
</header>

<form class="profile-form" [formGroup]="profileForm">
  <label class="field">
    <span>SET Area</span>
    <input
      type="text"
      formControlName="setArea"
      placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
    />
  </label>

  <label class="field">
    <span>Business Unit</span>
    <select formControlName="industry">
      <option value="" disabled>Select Business Unit</option>
      <option>Healthcare</option>
      <option>Energy</option>
      <option>Financial Services</option>
      <option>Government</option>
    </select>
  </label>

  <label class="field">
    <span>Primary Location impacted</span>
    <input
      type="text"
      formControlName="hqLocation"
      placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
    />
  </label>

  <label class="field">
    <span>Number of employees</span>
    <input
      type="text"
      formControlName="employeeCount"
      placeholder="e.g. 2,400"
    />
  </label>

  <div class="toggle-group">
    <label class="checkbox-row">
      <input type="checkbox" formControlName="uploadDocument" />
      <span class="checkbox-box"></span>
      <span>Upload Document</span>
    </label>

    <section class="upload-panel" *ngIf="showUploadSection">
      <div
        class="upload-card"
        [class.drag-over]="isDragOver"
        (dragover)="onDragOver($event)"
        (dragleave)="onDragLeave($event)"
        (drop)="onDrop($event)"
      >
        <h3>Upload Organizational profile account</h3>
        <p>Support doc, pdf &amp; text</p>
        <input
          #fileInput
          type="file"
          class="upload-input"
          accept=".doc,.docx,.pdf,.txt"
          (change)="onFileSelected($event)"
        />
        <button type="button" class="upload-button" (click)="fileInput.click()">
          <img
            src="assets/icons/upload_icon.svg"
            alt="Upload"
            class="upload-button-icon"
          />
          <span>Select File</span>
        </button>
        <span class="upload-note" *ngIf="selectedFileName; else uploadHint">
          {{ selectedFileName }}
        </span>
        <ng-template #uploadHint>
          <span class="upload-note">Or drag and drop your file here</span>
        </ng-template>
      </div>
    </section>

    <label class="checkbox-row">
      <input type="checkbox" formControlName="departmentFocus" />
      <span class="checkbox-box"></span>
      <span>Department / Process focus</span>
    </label>

    <section class="focus-panel" *ngIf="showDepartmentSection">
      <fieldset class="radio-group">
        <legend>Focus Type</legend>

        <label class="radio-row">
          <input type="radio" formControlName="focusType" value="process" />
          <span class="radio-mark"></span>
          <span>Process</span>
        </label>

        <label class="radio-row">
          <input type="radio" formControlName="focusType" value="department" />
          <span class="radio-mark"></span>
          <span>Department</span>
        </label>
      </fieldset>

      <label class="field">
        <span>Department Involved</span>
        <input
          type="text"
          formControlName="departmentInvolved"
          placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
        />
      </label>

      <label class="field">
        <span>Process Name</span>
        <input
          type="text"
          formControlName="processName"
          placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
        />
      </label>

      <label class="field">
        <span>Process Description</span>
        <input
          type="text"
          formControlName="processDescription"
          placeholder="e.g Acme Healthcare Group, City of Guadalajara (government)"
        />
      </label>
    </section>

    <label class="switch-row">
      <input type="checkbox" formControlName="criticalInfrastructure" />
      <span class="switch-pill">
        <span class="switch-knob"></span>
      </span>
      <span>Qualifies as Critical Infrastructure</span>
    </label>
  </div>
</form>
